<template>
    <ion-row
        
        class="row ion-justify-content-end"
        :class="{ 'custom-border': border }"
    >
        <ion-col size="6" class="flex items-center">
            <ion-label class="mt-4">{{ fieldLabel }}</ion-label>
        </ion-col>
        <ion-col size="6" class="flex justify-end ion-align-self-end">
            <slot />
        </ion-col>
    </ion-row>
</template>

<script
    setup
    lang="ts"
>

import { IonRow, IonCol, IonLabel } from '@ionic/vue';
import { computed } from 'vue';

const props = defineProps({
    label: {
        type: String,
        required: true
    },
    border: {
        type: Boolean,
        required: false,
        default: true
    },
    inputRequired: {
        type: Boolean,
        required: false,
        default: false
    }
});

const fieldLabel = computed(() => {
    return props.label + (props.inputRequired ? '*' : '');
});

</script>

<style scoped>
.custom-border {
    border-color: var(--ion-border-color, gray);
    border-bottom-width: 0.5px;
    border-bottom-style: solid;
}
</style>